import { SelectOption } from '@/models/selectOption'
import { UTILS } from './utils'

export const BRASIL_CODE = '55'

export const COUNTRY_CODE_OPTIONS: SelectOption[] = [
  { value: '963', label: 'Síria (+963)' },
  { value: '27', label: 'África do Sul (+27)' },
  { value: '49', label: 'Alemanha (+49)' },
  { value: '213', label: 'Argélia (+213)' },
  { value: '244', label: 'Angola (+244)' },
  { value: '966', label: 'Arábia Saudita (+966)' },
  { value: '54', label: 'Argentina (+54)' },
  { value: '374', label: 'Armênia (+374)' },
  { value: '61', label: 'Austrália (+61)' },
  { value: '43', label: 'Áustria (+43)' },
  { value: '994', label: 'Azerbaijão (+994)' },
  { value: '973', label: 'Bahrein (+973)' },
  { value: '880', label: 'Bangladesh (+880)' },
  { value: '375', label: 'Belarus (+375)' },
  { value: '32', label: 'Bélgica (+32)' },
  { value: '229', label: 'Benim (+229)' },
  { value: '591', label: 'Bolívia (+591)' },
  { value: '387', label: 'Bósnia e Herzegovina (+387)' },
  { value: '267', label: 'Botsuana (+267)' },
  { value: '55', label: 'Brasil (+55)' },
  { value: '359', label: 'Bulgária (+359)' },
  { value: '226', label: 'Burkina Faso (+226)' },
  { value: '257', label: 'Burundi (+257)' },
  { value: '238', label: 'Cabo Verde (+238)' },
  { value: '855', label: 'Camboja (+855)' },
  { value: '237', label: 'Camarões (+237)' },
  { value: '1', label: 'Canadá (+1)' },
  { value: '974', label: 'Catar (+974)' },
  { value: '7', label: 'Cazaquistão (+7)' },
  { value: '236', label: 'República Centro-Africana (+236)' },
  { value: '235', label: 'Chade (+235)' },
  { value: '56', label: 'Chile (+56)' },
  { value: '86', label: 'China (+86)' },
  { value: '357', label: 'Chipre (+357)' },
  { value: '57', label: 'Colômbia (+57)' },
  { value: '242', label: 'Congo (+242)' },
  { value: '243', label: 'Congo (RDC) (+243)' },
  { value: '82', label: 'Coreia do Sul (+82)' },
  { value: '225', label: 'Costa do Marfim (+225)' },
  { value: '506', label: 'Costa Rica (+506)' },
  { value: '385', label: 'Croácia (+385)' },
  { value: '420', label: 'Tchéquia (+420)' },
  { value: '45', label: 'Dinamarca (+45)' },
  { value: '253', label: 'Djibuti (+253)' },
  { value: '20', label: 'Egito (+20)' },
  { value: '503', label: 'El Salvador (+503)' },
  { value: '971', label: 'Emirados Árabes Unidos (+971)' },
  { value: '593', label: 'Equador (+593)' },
  { value: '421', label: 'Eslováquia (+421)' },
  { value: '386', label: 'Eslovênia (+386)' },
  { value: '34', label: 'Espanha (+34)' },
  { value: '1', label: 'Estados Unidos (+1)' },
  { value: '240', label: 'Guiné Equatorial (+240)' },
  { value: '372', label: 'Estônia (+372)' },
  { value: '251', label: 'Etiópia (+251)' },
  { value: '268', label: 'Eswatini (+268)' },
  { value: '679', label: 'Fiji (+679)' },
  { value: '63', label: 'Filipinas (+63)' },
  { value: '358', label: 'Finlândia (+358)' },
  { value: '33', label: 'França (+33)' },
  { value: '241', label: 'Gabão (+241)' },
  { value: '220', label: 'Gâmbia (+220)' },
  { value: '233', label: 'Gana (+233)' },
  { value: '995', label: 'Geórgia (+995)' },
  { value: '30', label: 'Grécia (+30)' },
  { value: '502', label: 'Guatemala (+502)' },
  { value: '224', label: 'Guiné (+224)' },
  { value: '245', label: 'Guiné-Bissau (+245)' },
  { value: '592', label: 'Guiana (+592)' },
  { value: '509', label: 'Haiti (+509)' },
  { value: '504', label: 'Honduras (+504)' },
  { value: '36', label: 'Hungria (+36)' },
  { value: '967', label: 'Iêmen (+967)' },
  { value: '354', label: 'Islândia (+354)' },
  { value: '91', label: 'Índia (+91)' },
  { value: '62', label: 'Indonésia (+62)' },
  { value: '98', label: 'Irã (+98)' },
  { value: '964', label: 'Iraque (+964)' },
  { value: '353', label: 'Irlanda (+353)' },
  { value: '972', label: 'Israel (+972)' },
  { value: '39', label: 'Itália (+39)' },
  { value: '81', label: 'Japão (+81)' },
  { value: '962', label: 'Jordânia (+962)' },
  { value: '254', label: 'Quênia (+254)' },
  { value: '965', label: 'Kuwait (+965)' },
  { value: '996', label: 'Quirguistão (+996)' },
  { value: '856', label: 'Laos (+856)' },
  { value: '371', label: 'Letônia (+371)' },
  { value: '961', label: 'Líbano (+961)' },
  { value: '266', label: 'Lesoto (+266)' },
  { value: '231', label: 'Libéria (+231)' },
  { value: '218', label: 'Líbia (+218)' },
  { value: '370', label: 'Lituânia (+370)' },
  { value: '352', label: 'Luxemburgo (+352)' },
  { value: '261', label: 'Madagascar (+261)' },
  { value: '389', label: 'Macedônia do Norte (+389)' },
  { value: '265', label: 'Malawi (+265)' },
  { value: '60', label: 'Malásia (+60)' },
  { value: '223', label: 'Mali (+223)' },
  { value: '356', label: 'Malta (+356)' },
  { value: '212', label: 'Marrocos (+212)' },
  { value: '222', label: 'Mauritânia (+222)' },
  { value: '230', label: 'Maurício (+230)' },
  { value: '52', label: 'México (+52)' },
  { value: '373', label: 'Moldávia (+373)' },
  { value: '976', label: 'Mongólia (+976)' },
  { value: '382', label: 'Montenegro (+382)' },
  { value: '258', label: 'Moçambique (+258)' },
  { value: '95', label: 'Mianmar (+95)' },
  { value: '264', label: 'Namíbia (+264)' },
  { value: '977', label: 'Nepal (+977)' },
  { value: '505', label: 'Nicarágua (+505)' },
  { value: '227', label: 'Níger (+227)' },
  { value: '234', label: 'Nigéria (+234)' },
  { value: '47', label: 'Noruega (+47)' },
  { value: '64', label: 'Nova Zelândia (+64)' },
  { value: '968', label: 'Omã (+968)' },
  { value: '31', label: 'Países Baixos (+31)' },
  { value: '92', label: 'Paquistão (+92)' },
  { value: '507', label: 'Panamá (+507)' },
  { value: '595', label: 'Paraguai (+595)' },
  { value: '51', label: 'Peru (+51)' },
  { value: '48', label: 'Polônia (+48)' },
  { value: '351', label: 'Portugal (+351)' },
  { value: '40', label: 'Romênia (+40)' },
  { value: '7', label: 'Rússia (+7)' },
  { value: '250', label: 'Ruanda (+250)' },
  { value: '221', label: 'Senegal (+221)' },
  { value: '381', label: 'Sérvia (+381)' },
  { value: '248', label: 'Seicheles (+248)' },
  { value: '232', label: 'Serra Leoa (+232)' },
  { value: '65', label: 'Singapura (+65)' },
  { value: '94', label: 'Sri Lanka (+94)' },
  { value: '249', label: 'Sudão (+249)' },
  { value: '211', label: 'Sudão do Sul (+211)' },
  { value: '597', label: 'Suriname (+597)' },
  { value: '46', label: 'Suécia (+46)' },
  { value: '41', label: 'Suíça (+41)' },
  { value: '886', label: 'Taiwan (+886)' },
  { value: '992', label: 'Tadjiquistão (+992)' },
  { value: '255', label: 'Tanzânia (+255)' },
  { value: '66', label: 'Tailândia (+66)' },
  { value: '228', label: 'Togo (+228)' },
  { value: '216', label: 'Tunísia (+216)' },
  { value: '90', label: 'Turquia (+90)' },
  { value: '993', label: 'Turcomenistão (+993)' },
  { value: '256', label: 'Uganda (+256)' },
  { value: '380', label: 'Ucrânia (+380)' },
  { value: '44', label: 'Reino Unido (+44)' },
  { value: '598', label: 'Uruguai (+598)' },
  { value: '998', label: 'Uzbequistão (+998)' },
  { value: '58', label: 'Venezuela (+58)' },
  { value: '84', label: 'Vietnã (+84)' },
  { value: '260', label: 'Zâmbia (+260)' },
  { value: '263', label: 'Zimbábue (+263)' },
]

const COUNTRY_CODES_BY_LENGTH = [
  ...new Set(COUNTRY_CODE_OPTIONS.map((option) => option.value)),
].sort((firstCode, secondCode) => {
  if (secondCode.length !== firstCode.length) {
    return secondCode.length - firstCode.length
  }

  return firstCode.localeCompare(secondCode)
})

const WHATSAPP_IDENTIFIER_SUFFIXES = [
  '@lid',
  '@g.us',
  '@broadcast',
  '@newsletter',
  '@c.us',
  '@s.whatsapp.net',
]

export function isWhatsappIdentifierContact(value?: string | null) {
  const normalizedValue = (value ?? UTILS.BLANK).trim().toLowerCase()

  return WHATSAPP_IDENTIFIER_SUFFIXES.some((suffix) =>
    normalizedValue.endsWith(suffix)
  )
}

export function normalizeWhatsappContactIdentifier(value: string) {
  return isWhatsappIdentifierContact(value)
    ? value.trim().toLowerCase()
    : value.replace(/\D/g, UTILS.BLANK)
}

export function splitPhoneNumberByCountryCode(phoneNumber: string) {
  if (isWhatsappIdentifierContact(phoneNumber)) {
    return {
      countryCode: UTILS.BLANK,
      cellPhone: normalizeWhatsappContactIdentifier(phoneNumber),
    }
  }

  const normalizedPhoneNumber = phoneNumber.replace(/\D/g, UTILS.BLANK)
  const countryCode =
    COUNTRY_CODES_BY_LENGTH.find((code) =>
      normalizedPhoneNumber.startsWith(code)
    ) ?? BRASIL_CODE

  return {
    countryCode,
    cellPhone: normalizedPhoneNumber.slice(countryCode.length),
  }
}
